export default {
  X_BUTTON: "X_BUTTON",
  UNDERLINE_BUTTON: "UNDERLINE_BUTTON",
  FAB_BUTTON: "FAB_BUTTON",
  CLIENT_BUTTON: "CLIENT_BUTTON",
  ESC_CLICK: "ESC_CLICK",
  PROMPT_SUGGESTION_CLICK: "PROMPT_SUGGESTION_CLICK",
};
